import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import PageWrapper from '../components/PageWrapper';

const DisclaimerPage = () => {
  const navigate = useNavigate();
  const effectiveDate = "January 19, 2026";

  return (
    <PageWrapper>
      <button 
        onClick={() => navigate(-1)} 
        className="back-btn"
        data-testid="back-btn"
      >
        ← Back
      </button>

      <article className="legal-page" data-testid="disclaimer-page">
        <h1>Medical Disclaimer</h1>
        <p className="effective-date"><strong>Effective Date:</strong> {effectiveDate}</p>

        <div className="legal-content">
          <p>
            Uro2Go is provided solely for general educational and informational purposes. 
            Content on this platform, including text, images, video, audio, tools, templates, 
            and other materials, is not intended to constitute medical advice, diagnosis, or 
            treatment and must not be relied upon as such.
          </p>

          <p>
            Use of Uro2Go does not create a physician–patient relationship or any other 
            professional relationship between users and Uro2Go, its owners, operators, 
            contributors, or affiliated clinicians.
          </p>

          <div className="warning-box">
            <AlertTriangle size={20} />
            <div>
              <strong>Emergency Notice</strong>
              <p>
                Uro2Go is not intended for use in medical emergencies. If you believe you 
                may be experiencing a medical emergency, call 911 or your local emergency 
                number immediately.
              </p>
            </div>
          </div>

          <p>
            Medical information evolves rapidly and may be incomplete, inaccurate, or outdated. 
            Uro2Go makes no representations or warranties regarding accuracy, completeness, or 
            applicability.
          </p>

          <p>
            Users assume all risk associated with use of the platform and any reliance on content.
          </p>

          <p>
            Uro2Go disclaims all liability for damages or losses arising from use of or reliance 
            on the platform to the fullest extent permitted by law.
          </p>
        </div>
      </article>
    </PageWrapper>
  );
};

export default DisclaimerPage;
